import type { IconProps } from './types';

export function Fantasia({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M48 132 Q48 100 80 100 Q128 100 176 100 Q208 100 208 132 Q208 144 208 152 Q208 180 180 180 Q156 180 144 152 Q138 142 132 132 Q128 130 124 132 Q118 142 112 152 Q100 180 76 180 Q48 180 48 152 Q48 144 48 132 Z" />
      <ellipse cx="84" cy="140" rx="16" ry="12" />
      <ellipse cx="172" cy="140" rx="16" ry="12" />
      <path d="M48 104 Q32 80 36 52 Q52 68 60 96" />
      <path d="M208 104 Q224 80 220 52 Q204 68 196 96" />
    </svg>
  );
}
